import React from "react";
import { hasValue } from "utilities/filters/filters";
import Filter, { FilterProps } from "./Filter";
import { useQueryParamObjectWith } from "polyrouter";
import { AllQueryParam } from "polyrouter/allQueryParams";
import { keyIter } from "utilities/objectUtils";

export type PolicyFilterState = {
  site?: string;
  group?: string;
  user_group?: string;
  device?: string;
};

export const defaultFilterState: PolicyFilterState = {
  site: undefined,
  group: undefined,
  user_group: undefined,
  device: undefined
};

export const PolicyFilter = (props: FilterProps<PolicyFilterState>) => (
  <Filter {...props} />
);

export const arePolicyFiltersSelected = (
  filterValues: PolicyFilterState
): boolean => {
  let filtersSelected = false;
  keyIter(defaultFilterState).forEach(key => {
    if (hasValue(filterValues, key)) {
      filtersSelected = true;
    }
  });

  return filtersSelected;
};

export const usePolicyFilterValue = () => {
  return useQueryParamObjectWith<AllQueryParam, PolicyFilterState>(
    "PolicyFilterState",
    defaultFilterState
  );
};
